import { useEffect } from "react";
import { useUtilsStore } from "../../../../stores/Utils/selects";
import { usePartnerRequestsStore2 } from "../../../../stores/Cac/Partner/partnerRequests";
import { getCategoriesDocRequestByIdPartner } from "../../../../services/Api/partnerService";
import { useParams } from "react-router-dom";
import { showToastError } from "../../../../services/Toasts/toasts";

const SelectCategories = () => {
  const { choiceModal, missionData, dataRequest } = usePartnerRequestsStore2();
  const { categories, setCategories } = useUtilsStore();
  const { idPartner } = useParams();

  const setCategoryId = (categoryId: number) => {
    usePartnerRequestsStore2.setState((state) => ({
      dataRequest: {
        ...state.dataRequest,
        categoryId,
      },
    }));
  };

  useEffect(() => {
    if (idPartner)
      getCategoriesDocRequestByIdPartner(
        parseInt(idPartner),
        missionData?.categoryId,
      )
        .then((data) => {
          setCategories(data);

          const defaultCategory = data?.find(
            (category: { isDefault?: boolean }) => category.isDefault,
          );
          if (defaultCategory) {
            setCategoryId(defaultCategory.id);
          }
        })
        .catch(() => showToastError("Une erreur s'est produite"));
  }, [choiceModal, missionData?.id, missionData?.categoryId]);

  return (
    <select
      name="categories"
      id="category"
      onChange={(e) => setCategoryId(parseInt(e.target.value))}
      value={dataRequest.categoryId || ""}
      className="w-full h-10 p-1 border border-gray-300 rounded-md mr-2 shadow-md font-BarlowCondensed"
    >
      {dataRequest.categoryId === 0 && (
        <option value="" className="text-slate-300">
          Choisir une catégorie
        </option>
      )}
      {categories?.map((category) => (
        <option value={category?.id} key={category?.id}>
          {category?.name}
        </option>
      ))}
    </select>
  );
};

export default SelectCategories;
